<template>
  <div class="modal-container-height">

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import PoDetailModal from "@/components/InvoiceAndPurchaseOrders/PoDetailModal";


export default {
  name: "PODetailModalContainer",
  components: {},
  created() {
    this.getPurchaseOrders()
  },
  computed: {
  ...mapGetters(["purchaseOrdersFormattedList"]),
  },
  methods: {
    ...mapActions(['fetchPurchaseOrders']),
    showFilteredData() {
      let filteredList = this.purchaseOrdersFormattedList.filter(item => item[this.$route.params.key] === this.$route.params.value);
      if (filteredList && filteredList.length === 1) {
        this.openPurchaseOrderDetails(filteredList[0])
      }
    },
    async getPurchaseOrders() {
      if(!this.purchaseOrdersFormattedList || this.purchaseOrdersFormattedList.length===0)
        await this.fetchPurchaseOrders();
      if (this.$route.params && this.$route.params.key && this.$route.params.value) {
        this.showFilteredData()
      }
    },
    openPurchaseOrderDetails(purchaseOrder) {
      document.documentElement.style.overflow = "hidden";
      this.$modal.show(
          PoDetailModal,
          {purchaseOrder},
          {
            name: 'poDetailModal',
            adaptive: true,
            height: "700",
            width: "85%",
            classes: ["app-modal"],
          },
          {
            'closed': () => {
              document.documentElement.style.overflow = "auto";
            },
          }
      );
    }
  }
}
</script>

<style scoped>
.modal-container-height {
  height: 100vh;
}
</style>